var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.338,
    height: 22.561,
    viewBox: "0 0 16.338 22.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8243",
    "data-name": "Group 8243",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8242",
    "data-name": "Group 8242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16842",
    "data-name": "Path 16842",
    d: "M5656.72,2021.418a8.169,8.169,0,0,1,14.755-4.741,7.908,7.908,0,0,1,1.221,7.151,23.921,23.921,0,0,1-3.7,7.2c-1.069,1.51-2.246,2.945-3.395,4.4-.467.591-.918.578-1.406.006a43.841,43.841,0,0,1-5.678-8.137,15.05,15.05,0,0,1-1.685-4.7C5656.776,2022.218,5656.759,2021.838,5656.72,2021.418Zm8.167,12.568c.11-.126.2-.213.267-.309.96-1.275,1.962-2.521,2.868-3.833a22.162,22.162,0,0,0,3.282-6.478,6.494,6.494,0,0,0-.261-4.516,6.652,6.652,0,0,0-9.751-2.983,6.5,6.5,0,0,0-2.989,4.561,7.6,7.6,0,0,0,.609,4.183A36.93,36.93,0,0,0,5664.886,2033.987Z",
    transform: "translate(-5656.72 -2013.303)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16843",
    "data-name": "Path 16843",
    d: "M5691,2043.425a4.1,4.1,0,1,1-4.1-4.125A4.1,4.1,0,0,1,5691,2043.425Zm-1.474-.018a2.625,2.625,0,1,0-2.636,2.642A2.618,2.618,0,0,0,5689.524,2043.407Z",
    transform: "translate(-5678.72 -2035.233)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.0e07415429adda570f87da62fd01a33d.svg";
export { ForwardRef as ReactComponent };